// Agent module routes
import { createRouter, createWebHistory } from "vue-router";
import Utils from "@/project/Source/utils";
import { i18n } from "@/project/Source/lang/i18n";
import Session from "../project/Session.vue";
import SignIn from "../project/Auth/Login.vue";
import ProductsCatalog from "../project/Catalog/ProductsCatalog.vue";
import CatalogProductInsertPage from "../project/Catalog/CatalogProductInsertPage.vue";
import HezabatPoliciesPage from "../project/Reports/HezabatPoliciesPage.vue";
import PolicyDetailPage from "../project/Reports/PolicyDetailPage.vue";
import HezabatCustomersPage from "../project/Reports/HezabatCustomersPage.vue";
import Error from "../project/Error/Error.vue";
import Cancel from "../project/Error/Cancel.vue";

const t = (key, params = {}) => {
  let translation = i18n.global.t(key, params);
  Object.keys(params).forEach((param) => {
    translation = translation.replace(`{${param}}`, params[param]);
  });
  return translation;
};

const breadcrumb = (label) => [{ path: null, label }];

const routes = [
  { path: "/Session/:id?", name: "Session", component: Session },
  { path: "/", redirect: "/signIn" },

  {
    path: "/catalog",
    component: ProductsCatalog,
    beforeEnter: (_to, _from, next) => {
      Utils.SetBreadcrumb(breadcrumb(t("productsLabel")));
      next();
    },
  },
  {
    path: "/catalog/insert/:productId",
    name: "CatalogProductInsert",
    component: CatalogProductInsertPage,
    beforeEnter: (_to, _from, next) => {
      Utils.SetBreadcrumb([
        { path: "/catalog", label: t("productsLabel") },
        { path: null, label: t("catalogInsertTitle") },
      ]);
      next();
    },
  },
  {
    path: "/policies",
    component: HezabatPoliciesPage,
    beforeEnter: (_to, _from, next) => {
      Utils.SetBreadcrumb(breadcrumb(t("policiesLabel")));
      next();
    },
  },
  {
    path: "/policies/:id",
    name: "PolicyDetail",
    component: PolicyDetailPage,
    beforeEnter: (to, _from, next) => {
      Utils.SetBreadcrumb([
        { path: "/policies", label: t("policiesLabel") },
        { path: null, label: to.params.id },
      ]);
      next();
    },
  },
  {
    path: "/reports/customers",
    component: HezabatCustomersPage,
    beforeEnter: (_to, _from, next) => {
      Utils.SetBreadcrumb([{ path: null, label: t("hezabatLabel") }]);
      next();
    },
  },

  { path: "/transactions", redirect: "/catalog" },
  { path: "/reports", redirect: "/reports/customers" },
  { path: "/reports/policies", redirect: "/policies" },
  { path: "/reports/policies/", redirect: "/policies" },
  { path: "/hezabat", redirect: "/policies" },
  { path: "/hezabat/policies", redirect: "/policies" },
  { path: "/reports/products", redirect: "/policies" },
  { path: "/hezabat/products", redirect: "/policies" },
  { path: "/hezabat/customers", redirect: "/reports/customers" },
  { path: "/search", redirect: "/catalog" },
  { path: "/dictionary", redirect: "/catalog" },
  { path: "/powerbi", redirect: "/catalog" },
  { path: "/signIn/:return?/:return2?/:return3?/:return4?", component: SignIn },

  {
    path: "/error",
    component: Error,
    beforeEnter: (_to, _from, next) => {
      Utils.SetBreadcrumb(breadcrumb(t("breadcrumbError")));
      next();
    },
  },
  {
    path: "/cancel",
    component: Cancel,
    beforeEnter: (_to, _from, next) => {
      Utils.SetBreadcrumb(breadcrumb(t("cancel")));
      next();
    },
  },

  { path: "/:pathMatch(.*)*", redirect: "/catalog" },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
